import React from 'react';
import ErrorBoundary from '@/app/common/components/ErrorBoundary';
import { HeaderShell } from './styled.ts';
import type { TitleProps } from './types';

export const ResultsHeaderShell = ({ isWaiting, children }: TitleProps & { children: React.ReactNode }) => (
  <ErrorBoundary id="SearchResultsHeader">
    <HeaderShell isWaiting={isWaiting}>{children}</HeaderShell>
  </ErrorBoundary>
);
